module.exports = __webpack_public_path__ + "static/media/logonav2.231b1f9d.png";